<script setup>
    const appName = process.env.APP_NAME;
    const assetUrl = process.env.ASSET_URL;

</script>

<template>
    <div class="logo z-30 flex items-center justify-start lg:hidden">
        <a class="relative" href="/">
            <img class="logo-mobile w-full"
              :src="assetUrl + 'EVEDLogoWhite.png'"
              :alt="appName">
        </a>
    </div>
    <div class="logo z-30 items-center justify-start hidden lg:flex">
        <a class="relative" href="/">
            <img class="logo-mobile w-full"
                 :src="assetUrl + 'EVEDLogoWhite.png'"
                 :alt="appName">
        </a>
    </div>
</template>

<style scoped lang="scss">
.flex-60 {
    flex: 0 0 15rem;
}
</style>
